/**
 * Created by mestrad on 2018. 06. 28..
 */

export default Base;
import AjaxRequest from "../../Ajax";

const $ = jQuery;

function Base (config){
    this.config = config;
}

Base.prototype.getOptionList = function(optionType, callback) {
    let ajaxUrl;
    let baseConfig = this.config;
    init();

    function init()
    {
        ajaxUrl = baseConfig.ajaxUrl;
        getData();
    }

    function getData()
    {
        if(window._sharedData[optionType] === undefined) {
            let request = {
                url: ajaxUrl + "/" + optionType,
                data: {
                    action: optionType,
                    object_type: baseConfig.objectType.toLowerCase(),
                    locale: baseConfig.locale,
                },
                success: function (response) {
                    if (response.success) {
                        callback(response.data);
                    }
                }
            };
            AjaxRequest(request);
        } else {
            callback(window._sharedData[optionType]);
        }
    }
};

Base.prototype.createSelect = function ( itemList, listType, itemClass, hasAll = false )
{
    return init();

    function init()
    {
        let selectCode = '<select id="' + listType + '" name="' + listType + '" class="nnp_search_select ' + itemClass + '">';
        if(hasAll) selectCode += '<option value="-1">Mind</option>';
        itemList.forEach(function(option) {
            selectCode += '<option value="' + option.id + '">' + option.title + '</option>';
        });
        selectCode += '</select>';
        return selectCode;
    }
};

Base.prototype.createDateIntervall = function ( config )
{
    let inputCode = '<input type="text" id="nnp_search_date_from" name="nnp_search_date_from" class="nnp input">' +
        '<span>-</span> ' +
        '<input type="text" id="nnp_search_date_to" name="nnp_search_date_to" class="nnp input">';

    function initDatepicker()
    {
        $(config.domElements.searchDateFrom).datepicker({
            dateFormat: "yy. mm. dd.",
            //changeMonth: true,
            changeYear: true,
            //showButtonPanel: true,
            locale: config.locale,
            gotoToday: true,
            yearRange: 'c-100:c',
            onChangeMonthYear: function () {
                var year = $( '#ui-datepicker-div .ui-datepicker-year :selected' ).val();
                $( this ).val( $.datepicker.formatDate( 'yy. mm. dd.', new Date( year, 0, 1 ) ) );
            }
        } ).focus( function () {
            $( '#ui-datepicker-div' ).position( {
                my: 'right bottom', at: 'right top', of: $( this )
            } );
        } ).attr( 'readonly', false );
        $(config.domElements.searchDateTo).datepicker({
            dateFormat: "yy. mm. dd.",
            // changeMonth: true,
            changeYear: true,
            // showButtonPanel: true,
            locale: config.locale,
            gotoToday: true,
            yearRange: 'c-100:c',
            onChangeMonthYear: function () {
                var year = $( '#ui-datepicker-div .ui-datepicker-year :selected' ).val();
                $( this ).val( $.datepicker.formatDate( 'yy. mm. dd.', new Date( year, 12, 0 ) ) );
            }
        } ).focus( function () {
            $( '#ui-datepicker-div' ).position( {
                my: 'right bottom', at: 'right top', of: $( this )
            } );
        } ).attr( 'readonly', false );
    }

    return {
        code: inputCode,
        initDatepicker: initDatepicker
    };
};

Base.prototype.createAutoCompleteInput = function (elementId) {
    return '<select class="nnp input filter_input ' + elementId + '" id="' + elementId + '" multiple="multiple" name="' + elementId + '"></select>';
};

Base.prototype.createInput = function ( itemName, hidden = false )
{
    if(hidden){
        return '<input type="text" class="nnp input filter_input ' + itemName + ' nnpHidden" id="' + itemName + '" name="' + itemName + '">';
    }
    return '<input type="text" class="nnp input filter_input ' + itemName + '" id="' + itemName + '" name="' + itemName + '">';
};

Base.prototype.createAddAndRemoveBtn = function ()
{
    return '<button type="button" class="addFilterBtn"> + </button><button type="button" class="removeFilterBtn"> - </button>';
};

Base.prototype.createRelationSelect = function ( filterCount )
{
    let options = [
        {
            "title": "és",
            "id": "and"
        },
        {
            'title': 'vagy',
            'id': 'or'
        },
        {
            'title': 'kizárás',
            'id': 'not'
        }
    ];
    if(filterCount > 0){
        return this.createSelect( options, this.config.domElements.filterRelationId + "_" + filterCount, this.config.domElements.filterRelationClass );
    }
    return this.createSelect( options, this.config.domElements.filterRelationId, this.config.domElements.filterRelationClass );
};

Base.prototype.getFilterTypes = function ( feed, extraFilters )
{
    let filterTypes = [
        {
            'title': 'Keresési kategória', 'id': '-1'
        }
    ];
    if(feed != null) {
        feed.forEach(function (item) {
            filterTypes.push({
                "title": item.title,
                "id": item.type
            });
        });
    }
    return $.merge( filterTypes, extraFilters );
};

Base.prototype.getCategoryItems = function ( type, categoryList )
{
    let items;
    categoryList.forEach(function(category){
        if(category.type === type){
            items = category.items;
        }
    });
    return items;
};

Base.prototype.getSelectId = function ( filterCount, type )
{
    if(filterCount === 0){
        return "nnpSearchFilter" + type;
    }
    return "nnpSearchFilter" + type + "_" + filterCount;
};

Base.prototype.addFilter = function ( selector, num, filterOptions, filterTypeId )
{
    let filter = $(selector).find("#nnpSearchSelectContainer").clone();
    filter.find( 'input, select' ).each( function ( i, v ) {
        if ( ! v.id ) {
            return;
        }
        var id = v.id.replace( /([a-zA-Z]+)_\d/, '$1' ) + '_' + num;
        $( v ).attr( { id: id, name: id } );
    } );
    filter.find("select").each(function(){
        let item = $(this);
        if("#" + item.attr("id") === filterTypeId){
            item.children().remove();
            filterOptions.forEach(function(optionItem){
                    item.append($("<option></option>")
                        .attr("value", optionItem.id)
                        .text(optionItem.title));
            });
        }
    });
    filter.find('select').css('height', '');
    $(selector).append(filter);
};

Base.prototype.removeFilter = function ( feed )
{
    let container = $(feed).closest('#nnpSearchSelectContainer');
    $(container).remove();
};

Base.prototype.refreshSearchWrapper = function ( filterTypeOptions, selectId )
{
    let config = this.config;
    let select = $(selectId);
    $("#customSearchWrapper select").each(function(){
        if ($(this).hasClass('filter_relation')){
            return;
        }
        let item = $("#" + this.id);
        if((item.hasClass(config.domElements.filterTypesClass) && this.id !== selectId) || selectId === undefined){
            item.children("option:not(:selected)").remove();
            filterTypeOptions.forEach(function(optionItem){
                if(optionItem.title !== item.children("option:selected").text()){
                    item.append($("<option></option>")
                        .attr("value", optionItem.id)
                        .text(optionItem.title));
                }
            });
        }
    });
};
